import React, { useEffect, useRef, useState } from "react";
import { useAxiosContext } from "../../context/AxiosContext";
import useClickOutside from "../../hooks/useClickOutside";
import Input from "../../components/FormComponents/Input";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const ScreenTagFilters = ({ checkedFilters, setCheckedFilters, customStyles }) => {
  const [allTags, setAllTags] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const { axiosInstance } = useAxiosContext();
  const popupOptionDivRef = useRef();

  useClickOutside(popupOptionDivRef, () => setShowOptions(false));

  const handleCheckboxChange = (id, type) => {
    if (id === "clear_all") {
      setCheckedFilters({
        ...checkedFilters,
        [type]: []
      });
      return;
    }

    const updatedFilters = checkedFilters[type].includes(id)
      ? checkedFilters[type].filter((tag) => tag !== id)
      : [...checkedFilters[type], id];

    setCheckedFilters({ ...checkedFilters, [type]: updatedFilters });
  };

  const fetchAllTags = async () => {
    try {
      const { data } = await axiosInstance.get(`/tag`);
      setAllTags(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showOptions) {
      fetchAllTags();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOptions]);

  const filterCount = checkedFilters.tags?.length || 0;

  return (
    <div className="menu_container" onClick={() => setShowOptions(!showOptions)} ref={popupOptionDivRef}>
      <div className="filter_items">
        <MaterialIcon
          name="filter_alt"
          className="sidebar_icons"
          title="Filter Tags"
          style={{
            color: showOptions ? "var(--builder-primary)" : "var(--builder-icon-color)"
          }}
        />
        {filterCount > 0 && <span className="item_count">{filterCount}</span>}
      </div>
      {showOptions && (
        <div className="filter_blocks_outer" style={customStyles}>
          <div className="mb_2">
            <div className="filter_block_heading font_weight_medium">
              <span style={{ fontSize: "12px", fontWeight: "600" }}>Tags ({allTags.length})</span>
              {checkedFilters.tags?.length > 0 && (
                <button
                  className="clear_all_btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckboxChange("clear_all", "tags");
                  }}
                >
                  Clear All
                </button>
              )}
            </div>
            {allTags.map((tag) => (
              <div key={tag.id} className="popup_list_items justify_between" onClick={(e) => e.stopPropagation()}>
                <span className="sidebar_filter_item">{tag.name}</span>
                <div className="checkbox_list">
                  <Input
                    type="checkbox"
                    id={tag.id}
                    checked={checkedFilters.tags?.includes(tag.id)}
                    onChange={() => handleCheckboxChange(tag.id, "tags")}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ScreenTagFilters;
